(function(){

  angular.module('irricrops')

    .controller("productividadCtrl", ["$scope","MultiChart","Config","$timeout","productividadFac", "vinedoData", "File","vinedo","urls","$stateParams","$state", "cuartelDialog",
      function( $scope, MultiChart, Config, $timeout, productividadFac, vinedoData, File, vinedo, urls, $stateParams, $state, cuartelDialog){

        $scope.cuarteles      = vinedoData.data.data.cuarteles;
        $scope.xlsLoading     = false;
        $scope.vinedo_id      = vinedo.data.id;
        $scope.vinedo_nombre  = vinedo.data.nombre;
        $scope.formatoLoading = false;


        $scope.showDialogSector = function(ev, sector) {
          cuartelDialog.showDialog(ev, sector.id);
        }

        $scope.activeItemList = function(cuartel){
          if (!angular.equals(cuartel, $scope.itemSelected)) {

            $scope.setItemSelectedNull(false);
            cuartel.loadingChart = true;
            $state.go('vinedo.productividad', {cid: cuartel.id});

            if(cuartel != $scope.itemSelected && angular.isUndefined(cuartel.h)) {
              productividadFac.getGraficoCuartel(cuartel.id).success(function(res){
                //cuartel.datos_tabla.kg_mt.cantidad = cuartel.datos_tabla.kg_mt.cantidad || 0;
                //cuartel.datos_tabla.kg_planta.cantidad = cuartel.datos_tabla.kg_planta.cantidad || 0;
                //cuartel.datos_tabla.kg_ha.cantidad = cuartel.datos_tabla.kg_ha.cantidad || 0;
                startMultiChart(cuartel, res.data);
                cuartel.loadingChart = false;
              });
            }else{
              cuartel.loadingChart = false;
            }

            cuartel.active = true;
            $scope.itemSelected = cuartel;

            $timeout(function() {
              cuartelElement = $("#prod-cuartel-"+cuartel.id);
              $("#content").animate({
                scrollTop : $("#content").scrollTop() + cuartelElement.position().top
              }, 100);
            }, 0);

            $(".backdrop-list").height($("#content")[0].scrollHeight);
            $timeout(function(){
              $(".backdrop-list").height($("#content")[0].scrollHeight);
            }, 100);
            $timeout(function(){
              $(".backdrop-list").height($("#content")[0].scrollHeight);
            }, 1000);

          }
        };



        $scope.setItemSelectedNull = function(reset){
          reset = reset || true;
          $scope.itemSelected = null;
          //$scope.clearDetailsSelected();
          angular.forEach($scope.cuarteles, function(cuartel) {
            cuartel.active = false;
          });
          if (reset) {
            $timeout(function() {
              $("#content").animate({
                scrollTop : $("#content").scrollTop() -100
              }, 200);
            }, 0);
            $state.go('vinedo.productividad', {cid: null});
          }
        };



        $scope.checkSelectQueryUrl = function() {
          if (angular.isDefined($stateParams.cid)) {
            var cuartelSelected = null;
            angular.forEach($scope.cuarteles, function(cuartel) {
              if (cuartel.id == $stateParams.cid) {
                cuartelSelected = cuartel;
              }
            });
            $scope.activeItemList(cuartelSelected);
          }
        };


        /**
          * @ngdoc method
          * @name irricrops.productividadCtrl#openMenu
          * @methodOf irricrops.productividadCtrl
          *
          * @description
          * para mejora de apertura de md-menu, sacado de la documentacion de angular-material
          *
          * @param {object} $mdOpenMenu menu clickeado
          * @param {Event} ev evento click en menu
        **/
        $scope.openMenu = function($mdOpenMenu, ev) {
          //originatorEv = ev;
          $mdOpenMenu(ev);
        };



        /**
          * @ngdoc method
          * @name irricrops.productividadCtrl#xlsRRFormato
          * @methodOf irricrops.productividadCtrl
          *
          * @description
          * Descarga xls de formato de productividad
          * con datos reales
        **/
        $scope.descargarFormato= function(){
          File.download(
            urls.BASE+'/vinedo/excel-produccion',
            {
              vinedo_id: $scope.vinedo_id, //.data.vinedo.id,
              filename: "FormatoProductividad_"+$scope.vinedo_nombre+".xls",
              method: "get"
            },
            function(){
              $scope.formatoLoading = true;
            },
            function(){
              //success
              $scope.formatoLoading = false;
            },
            function(){
              //error
              $scope.formatoLoading = false;
            }
          );
        };

        var startMultiChart = function(cuartel, dataGrafico) {

          // angular.forEach($scope.cuarteles, function(cuartel, key) {

            cuartel.h = new MultiChart("Comparación de productividad entre temporadas");


            var datosPesoPoda   = [];
            var datosBayas      = [];
            var datosProduccion = [];
            var datosRavaz      = [];
            var datosVolumenHa  = [];

            angular.forEach(dataGrafico.periodos, function (val, k) {
              // val.unix = moment("01-01-"+k).unix();

              if (val.data.poda === null) {
                datosPesoPoda.push([val.periodo, null]);
              }else{
                datosPesoPoda.push([val.periodo, parseFloat(val.data.poda)]);
              }
              if ( val.data.bayas === null) {
                datosBayas.push([val.periodo, null]);
              }else{
                datosBayas.push([val.periodo, parseFloat(val.data.bayas)]);
              }

              if  (val.data.produccion === null) {
                datosProduccion.push([val.periodo, null]);
              }else{
                datosProduccion.push([val.periodo, parseFloat(val.data.produccion)]);
              }

              if  (val.data.indice_ravaz === null || angular.isUndefined(val.data.indice_ravaz)) {
                datosRavaz.push([val.periodo, null]);
              }else{
                datosRavaz.push([val.periodo, parseFloat(val.data.indice_ravaz)]);
              }

              if  (val.data.volumen_ha=== null || angular.isUndefined(val.data.volumen_ha)) {
                datosVolumenHa.push([val.periodo, null]);
              }else{
                datosVolumenHa.push([val.periodo, parseFloat(val.data.volumen_ha)]);
              }
            });

            cuartel.h.agregarSerie({
              color     : Config.colors.riegoReal.background,
              name      : 'Volumen m<sup>3</sup> / ha',
              type      : 'column',
              width     : 15,
              yAxis     : 7,
              suffix    : ' m<sup>3</sup>/ha',
              data      : datosVolumenHa
            });


            cuartel.h.agregarSerie({
              color     : Config.colors.pesoPoda.background,
              name      : 'Peso Poda kg/mts',
              yAxis     : 8,
              lineWidth : 2,
              suffix    : ' kg/mt',
              data      : datosPesoPoda
            });

            cuartel.h.agregarSerie({
              color  : Config.colors.bayas.background,
              name   : 'bayas / racimo',
              markerSymbol : 'circle',
              radius : 2,
              yAxis  : 9,
              suffix : ' b/r',
              data   : datosBayas,
              visible: false
            });


            cuartel.h.agregarSerie({
              color     : Config.colors.produccion.background,
              name      : 'Produccion ton/ha',
              type      : 'column',
              yAxis     : 10,
              width     : 15,
              suffix    : ' ton/ha',
              data      : datosProduccion
            });


            cuartel.h.agregarSerie({
              color     : Config.colors.ravaz.background,
              name      : 'Indice de Ravaz',
              yAxis     : 11,
              lineWidth : 2,
              suffix    : '',
              data      : datosRavaz
            });


            cuartel.HMChartConfig = cuartel.h.getConfig();

          // });
        };
        // startMultiChart();

        $scope.subirXls = function(file, invalidFiles) {
          $scope.xlsLoading = true;
          File.upload(file, invalidFiles, "vinedo/excel-produccion", "archivo").then(function(res){
            $scope.xlsLoading = false;
            angular.forEach($scope.cuarteles, function(cuartel, key) {
              cuartel.h = undefined;
            });
          });
        };


      }]);

})();
